import React, { useState } from "react";
import CalculatorPage from "./CalculatorPage";

function DaysBetweenDates() {
  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const [days, setDays] = useState(null);
  const [error, setError] = useState("");
  const [funFact, setFunFact] = useState("");
  const [showFunFact, setShowFunFact] = useState(false);

  const onInput = (setter) => (e) => {
    setter(e.target.value);
    setDays(null);
    setShowFunFact(false);
    setError("");
  };

  const calculateDays = () => {
    if (!date1 || !date2) {
      setError("Please select both dates.");
      setDays(null);
      setShowFunFact(false);
      return;
    }

    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const diffTime = Math.abs(d2 - d1);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    setError("");
    setDays(diffDays);

    const funFactsList = [
      "There are 365 days in a year, except leap years with 366 days.",
      "The Gregorian calendar was introduced in 1582.",
      "A leap year occurs every 4 years.",
      "Some cultures still use lunar calendars.",
      "February is the shortest month of the year.",
    ];

    setFunFact(funFactsList[Math.floor(Math.random() * funFactsList.length)]);
    setShowFunFact(true);
  };

  return (
    <CalculatorPage
      title="Days Between Dates"
      metaDescription="Free date calculator: count the exact number of days between any two dates — for deadlines, anniversaries, trips, and project planning."
      intro={
        <>
          Find out how many <strong>days</strong> are between two selected
          dates — in either order.
        </>
      }
      seoContent={
        <>
          <h2>How the count works</h2>
          <p>
            The calculator takes the difference between the two dates in
            milliseconds and converts it to whole days, automatically handling
            leap years and different month lengths. The order of the dates
            doesn't matter — it always returns a positive count.
          </p>
          <h2>Everyday uses</h2>
          <p>
            Count down to a wedding, work out how many days a visa or
            insurance policy covers, measure the length of a project or
            pregnancy, check notice periods, or settle how many days old a
            newborn is. Note the result counts the gap between the dates —
            if you need to include both endpoints (as some deadlines do), add
            one to the result.
          </p>
          <h2>Frequently asked questions</h2>
          <h3>Does the count include both the start and end dates?</h3>
          <p>
            No — it counts the gap between the two dates. If your situation
            counts both the first and last day (some notice periods and
            deadlines do), add one to the result.
          </p>
          <h3>Are leap years handled automatically?</h3>
          <p>
            Yes. The calculation works from the actual calendar dates, so leap
            years and different month lengths are accounted for without any
            adjustment on your part.
          </p>
          <h3>Does the order of the two dates matter?</h3>
          <p>
            No. You can enter them in either order and the calculator always
            returns a positive number of days.
          </p>
        </>
      }
    >
      <div className="fields">
        <label className="field">
          <span>Start Date</span>
          <input type="date" value={date1} onChange={onInput(setDate1)} />
        </label>
        <label className="field">
          <span>End Date</span>
          <input type="date" value={date2} onChange={onInput(setDate2)} />
        </label>
      </div>

      <button className="btn" onClick={calculateDays}>Calculate Days</button>

      {error && <div className="error">{error}</div>}

      {days !== null && (
        <>
          <div className="result">
            There are <strong>{days.toLocaleString()}</strong> days between
            the selected dates.
          </div>
          {showFunFact && (
            <div className="fun-fact fun-fact-animate">💡 {funFact}</div>
          )}
        </>
      )}
    </CalculatorPage>
  );
}

export default DaysBetweenDates;
